import { Pipe, PipeTransform } from '@angular/core';
// eslint-disable-next-line max-len
import { StatusDetalheImportacaoMovimentacaoCadastral } from 'src/app/core/models/movimentacao-cadastral/StatusDetalheImportacaoMovimentacaoCadastral';

@Pipe({
  name: 'statusDetalheMovimentacao',
})
export class StatusDetalheMovimentacaoPipe implements PipeTransform {
  transform(status: StatusDetalheImportacaoMovimentacaoCadastral): string {
    if (status === StatusDetalheImportacaoMovimentacaoCadastral.Erro) {
      return 'Erro';
    }

    return 'Sucesso';
  }
}
